import { Local, Category_Time , Section_Time } from './../../services/question.service';
import { Component, OnInit, Renderer2, HostListener, ViewChild, ElementRef,OnDestroy,QueryList,ViewChildren, ChangeDetectionStrategy, ChangeDetectorRef,TemplateRef, Inject, NgZone, Injectable,Input,AfterViewInit } from '@angular/core';
import { DomSanitizer ,  SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatIconRegistry } from '@angular/material/icon';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/observable/timer'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/take'
import { Pipe, PipeTransform } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import * as _ from 'lodash';
import { formatDate } from '@angular/common';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import * as RecordRTC from 'recordrtc';
import { VideoRecordingService } from '../../video-recording.service';


import {
  faFilter,
  faPauseCircle,
  faHome,
  faAngleLeft,
  faAngleRight,
  faInfoCircle,
  faPencilAlt
} from '@fortawesome/free-solid-svg-icons';
import { Router, ActivatedRoute, CanActivate } from '@angular/router';
import { Question, questionService } from 'src/app/services/question.service';
import { FormControl, FormGroup } from '@angular/forms';
import { SaveModel, SaveEssay } from './videoanswer.model';
import { LocationStrategy } from '@angular/common';
// import { DraggableComponent } from '../draggable/draggable.component';
import { ConfigService, evaluate_user } from 'src/app/services/config.service';
import { endtestService, Endtest, Check_log_value } from 'src/app/services/endtest.service';
import { AudioRecordingService } from '../../audio-recording.service';
import { data } from 'jquery';

declare var $: any;
declare let jQuery: any;
@Component({
  selector: "app-videoanswer",
  templateUrl: "./videoanswer.component.html",
  styleUrls: ["./videoanswer.component.scss"],

  styles: [
    `
      .redClass {
        background-color: red;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
@Injectable()
export class VideoanswerComponent implements OnInit, CanActivate {
  @ViewChild("content") modalContent: TemplateRef<any>;

  @ViewChild("finish") modalFinish: ElementRef;
  @ViewChild("keyboard") modalKeyboard: TemplateRef<any>;
  @ViewChild("Start") modalStart: TemplateRef<any>;
  @ViewChild("FileSizeExceeded") modalFileSizeExceeded: TemplateRef<any>;
  @ViewChild("rightclick") modalRightClick: TemplateRef<any>;
  @ViewChild("timeralert") modalTimerAlert: TemplateRef<any>;
  @ViewChild("alert", { static: true }) alert: ElementRef;
  @ViewChild("myroughspace") modalRoughspace: TemplateRef<any>;
  @ViewChild("imagePreview") modalImagePreview: TemplateRef<any>;
  @ViewChild("text") text: ElementRef;
  //@ViewChild(MathjaxComponent) childView: MathjaxComponent;
  @ViewChild("equation") equation: ElementRef;
  @Input(" MathJax")
  @Input("MathJax")
  fractionString: string;
  @ViewChildren("videoElement") videoElement: QueryList<ElementRef>;
  // @ViewChildren("videoElement") videoElement: QueryList<ElementRef>;
  private isAudioElementReady = false;

  private isVideoElementReady = false;
  video: any;
  isPlaying = false;
  isVideoRecordingArray = [];
  displayControls = true;
  isAudioRecording = false;
  isVideoRecording = false;
  audioRecordedTime;
  videoRecordedTime;
  // videoBlobUrl = null;
  audioBlob;
  videoBlob;
  audioName;
  videoName;
  blobArrays = new Map<String, Array<any>>();
  videoBlobUrlArray = [];
  dataurl: any;
  audioStream;
  videoStream: MediaStream;
  audioConf = { audio: true };
  videoConf = {
    video: { facingMode: "user", width: 400, height: 200 },
    audio: { echoCancellation: true }
  };
  private audioObj = new Audio();
  elem;
  essay_str = Array<{ essay: string; questionid: number }>();
  save_essay: Array<SaveEssay> = [];
  data_str = Array<{ essay: string; questionid: number }>();
  save_data: Array<SaveEssay> = [];

  toggleClass = "ft-minimize";
  today = new Date();
  todaysDataTime = "";
  public config: any = {};
  eee: boolean;
  input: any;
  func: any;
  textValue: string = "";
  taker_id: any;
  showModal5: boolean;
  showModal1: boolean;
  showModal2: boolean;
  showModal: boolean;
  zero: number = 0;
  n: any;
  caretPos: number = 0;

  // roughspace: boolean=false;
  //word count
  public remainingWords = 5;

  public textareaForm = new FormGroup({
    textinput: new FormControl()
  });
  str: string;
  Fullscreen: any;
  buttonclick: boolean = false;
  checked: boolean = false;
  public isEnding: boolean = false;
  public isFiltering: boolean = true;
  section: any[] = [];
  closeResult: string;
  row_question: string;
  season_question: string;
  currentCheckedValue = null;
  cat_Id;
  radio_ques_id;
  radio_ans_id;
  type_ques_id: string;
  essay_id: string;
  sample = 20;
  id;
  set;
  paper;
  unanswered;
  visited_count;
  answered: number = 0;
  question: Question = {
    questionId: "",
    question_text: "",
    answerId: "",
    Answer_Text: "",
    Duration: ""
  };
  blobArrayString = [];
  check_loggedin: Check_log_value = {
    Test_Taker_User_Id: "",
    schedule_id: ""
  };
  user_id: evaluate_user = {
    id: ""
  };
  isAudioRecordingArray = [];

  // cat_set: Local = {
  //   Id: '',
  //   set: '',
  //   paper: ''
  // };
  temp_ques_id: any;
  questions: any;
  time: number;
  myTime: any;
  total: number;
  answer: any;
  length1: any;
  filter_answer_id: any;
  filter_answer_id1: any;
  category: any;
  questionIdarray = [];
  prevSelectedAnswerArray = new Map<string, Array<any>>();
  prevSelectedAnswer = null;
  //submit_final = new Array(this.length1);
  save_answer = Array<{
    roughspace: boolean;
    answerid: number;
    questionid: number;
    user_id: number;
    schedule_id: number;
    username: any;
  }>();
  qid = [];
  // save_answer = Array<{  answerid: number; questionid: number }>();
  // visitedArray= Array<{value:boolean;i:number}>();
  //visitedArrays=Array<{value:boolean;i:number}>();
  visitedArrays: any = [];
  currentThumbnail: any;
  visitedArray: any = [];
  fill: any = [];
  visited: any = [];
  filter = [];
  local: Local = {
    Id: "",
    paper: "",
    set: "",
    schedule: "",
    email: "",
    schedule_master_Id: ""
  };
  category_time: Category_Time = {
    start_time: "",
    end_time: "",
    category_id: "",
    user_id: ""
  };
  section_time: Section_Time = {
    start_time: "",
    end_time: "",
    section_name: "",
    user_id: "",
    email: "",
    category_id: ""
  };
  submit: Array<SaveModel> = [];
  fname: any;
  countDown;
  counter;
  tick = 1000;
  audio: any;
  cat: any;
  button_click: boolean = true;
  select: any = [];
  islogged: Endtest = {
    Id: "",
    Test_Taker_User_Id: "",
    Is_Logged: "",
    login_time: "",
    logoff_time: "",
    schedule_master_Id: ""
  };
  //save_essay:any=[];
  // public set:any;
  // public paper:any;
  // document: any;
  // modalService: any;
  //text: any;
  setAudioVideoFlag = [];
  words: any = [];
  wordCount: any;
  myvar: boolean = false;
  fCount: number;
  public url: any;
  focuscount: number = 0;
  private fn: Function;
  crt_value: any;
  color: any = "Violet";
  visited_value: boolean = true;
  i: number = 0;
  temp1 = `q${this.i} `;
  temp = `q${this.questionIdarray} `;
  arrlength: any;
  summa: any;
  section_button: any;
  roughspace: any;
  roughspace_filter: any = [];
  book_mark: any = [];
  end_button: any = [];
  start_time: string;
  category_start_time: string;
  arr: any;
  essay_ques_length: any;
  length: any;
  essay: boolean;
  audio_flag: boolean;
  video_flag: boolean;
  youtube_flag: boolean;
  video_id: string;
  not_essay: boolean;
  ques_index: any;
  esarr = [];
  wordc: any;
  roughspace_filter1: any = [];
  visit: any = 1;
  total_questions;
  stopblink: boolean;
  base64Image: any;
  thumbnail: any;
  dir: any;
  sectioncount: any;
  sectioncounter: any;
  keypress: boolean = false;
  delkeypress: boolean = false;
  lastPos: number = 0;
  user_logon_time: string;
  user_loggoff_time: string;
  logged: boolean;
  timer: any;
  timer_alert: number;
  timing: number;
  hourglass: boolean = false;
  timings: any;
  fractionString1: any = [];
  modalRef: any;
  modalCafe: any;
  displayname: string;
  categoryduration: any;
  escapetime: number;
  escape_count: number = 0;
  popupcounter: number = 0;
  pagealive: number = 0;
  datenow: number;
  date: Date;
  selectedQuestionId: any;
  prevQuestionId: any;
  // temp1 = `q${this.i} `;
  // Kill subject to stop all requests for component
  private killTrigger: Subject<void> = new Subject();
  question_length: any;
  code_Pos: number;
  code_tabpress: number = 0;
  Section_Id: any;
  first_question: any;
  tab_counter: number = 0;
  userId: string;
  email: string;
  schedule_id: string;
  bookmark_counter: number = 0;
  questioncounter: boolean = false;
  products: { category_Id: number; ProductId: number; Product_name: string }[];
  answer_text: any;
  q_url: any;
  media_url: any;
  previousSelectedTabIndex: any = [];
  safeSrc: SafeResourceUrl;
  private record;
  private recording = false;
  private recordingflag = false;
  private play = false;
  private audiourl;
  private error;
  private currenturl;
  private audiodataurl;
  recordingQuestionRow: any;
  recordingQuestionIndex: any;
  fileSize= [];
  audioOutputs=[];
  videoOutputs=[];
  falseResponseIds: any[];
  array: any;
  combinedIndividualAnsArray: any;
  dataURLToSave: any[];
  reachedMaxTime=false
  // videoBlobUrlArray: any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private ren: Renderer2,
    private location: LocationStrategy,
    private route: ActivatedRoute,
    private quest: questionService,
    public router: Router,
    iconRegistry: MatIconRegistry,
    private httpClient: HttpClient,
    private modal: NgbModal,
    private ngZone: NgZone,
    private modalService: NgbModal,
    private config1: ConfigService,
    private evaluate_user: endtestService,
    private Endtest: endtestService,
    private el: ElementRef,
    private _sanitizer: DomSanitizer,
    private ref: ChangeDetectorRef,
    private videoRecordingService: VideoRecordingService,
    private audioRecordingService: AudioRecordingService
  ) {
    iconRegistry.addSvgIcon(
      "thumbs-up",
      _sanitizer.bypassSecurityTrustResourceUrl("assets/filter_list.svg")
    );

    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isAudioRecording = false;
      this.ref.detectChanges();
    });

    this.audioRecordingService.getRecordedTime().subscribe(time => {
      this.audioRecordedTime = time;
      console.log("time***", time);
      if(time == '03:00'){
        this.stopAudioRecording(this.recordingQuestionRow,this.recordingQuestionIndex)
        this.reachedMaxTime = true
      }
      this.ref.detectChanges();
    });

    this.audioRecordingService.getRecordedBlob().subscribe(data => {
      console.log("data inside getRecordedBlob", data);
      this.audioBlob = data.blob;
      console.log("audioBlob*******", this.audioBlob);
      this.audioName = data.title;
      this.fileSize[`q${data.questionId}`] = data.size
      console.log("this.fileSize",this.fileSize)

      if (this.fileSize[`q${data.questionId}`] > 6) {
        this.modalRef = this.modal.open(this.modalFileSizeExceeded);
        setTimeout(() => {
          this.modalRef.close(this.modalFileSizeExceeded);
        }, 6000);
      }
      // this.audioBlobUrl = this._sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
      this.videoBlobUrlArray[
        `q${data.questionId}`
      ] = this._sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob)
      );
      console.log("videoBlobUrlArray", this.videoBlobUrlArray);

      blobToBase64(data.blob).then(res => {
        // console.log(res);
        this.dataurl = res;
        let b64 = this.dataurl.replace(/^data:.+;base64,/, "");
        this.audiodataurl = b64;
        var temp = data.questionId;
        this.blobArrays.set(`q${data.questionId}`, [b64, data.questionId,this.userId,this.schedule_id,this.email,null]);
        console.log("this.videoBlobUrlArray***", this.videoBlobUrlArray);
      });
      this.ref.detectChanges();
    });

    this.videoRecordingService.recordingFailed().subscribe(() => {
      this.isVideoRecording = false;
      this.ref.detectChanges();
    });

    this.videoRecordingService.getRecordedTime().subscribe(time => {
      this.videoRecordedTime = time;
      // console.log("time***",time)
      if(time == '03:00'){
        this.stopVideoRecording(this.recordingQuestionRow,this.recordingQuestionIndex)
        this.reachedMaxTime = true
      }
      this.ref.detectChanges();
    });

    this.videoRecordingService.getStream().subscribe(stream => {
      this.videoStream = stream;
      this.ref.detectChanges();
    });

    this.videoRecordingService.getRecordedBlob().subscribe(data => {
      console.log("data", data);
      console.log("video size******in mb", data.videoSize);
      this.videoBlob = data.blob;
      this.videoName = data.title;
      this.fileSize[`q${data.questionId}`] = data.videoSize
      console.log("this.fileSize",this.fileSize)

      if (this.fileSize[`q${data.questionId}`] > 6) {
        this.modalRef = this.modal.open(this.modalFileSizeExceeded);
        setTimeout(() => {
          this.modalRef.close(this.modalFileSizeExceeded);
        }, 3000);
      }
      // this.videoBlobUrl = this._sanitizer.bypassSecurityTrustUrl(data.url);
      this.videoBlobUrlArray[`q${data.questionId}`] = this._sanitizer.bypassSecurityTrustUrl(data.url);
      console.log("videoBlobUrlArray&*******", this.videoBlobUrlArray);

      blobToBase64(data.blob).then(res => {
        // console.log(res);
        this.dataurl = res;
        let b64 = this.dataurl.replace(/^data:.+;base64,/, "");
        // localStorage.setItem("videoblob", b64);

    
        this.blobArrays.set(`q${data.questionId}`, [b64, data.questionId,this.userId,this.schedule_id,this.email,null]);
        console.log("blobarray after insert", this.blobArrays);
      
      });
      this.ref.detectChanges();
    });
  }
  canActivate(
    route: import("@angular/router").ActivatedRouteSnapshot,
    state: import("@angular/router").RouterStateSnapshot
  ):
    | boolean
    | import("@angular/router").UrlTree
    | Observable<boolean | import("@angular/router").UrlTree>
    | Promise<boolean | import("@angular/router").UrlTree> {
    throw new Error("Method not implemented.");
  }

  ngAfterViewInit() {
    console.log("inside ngAfterViewInit ");
    this.isVideoElementReady = true;
    this.isAudioElementReady = true;
    console.log("this.videoElement*****",this.videoElement)
    console.log("this.videoElement*****",this.videoElement)
  }

  public ngOnInit() {
    const self = this;

    this.escapetime = 80000;
    this.sectioncount = JSON.parse(localStorage.getItem("section_counter"));
    this.fname = sessionStorage.getItem("fname");

    MathJax.Hub.Config({
      showMathMenu: false,
      tex2jax: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"]
        ]
      },
      menuSettings: { zoom: "Double-Click", zscale: "150%" },
      CommonHTML: { linebreaks: { automatic: true } },
      "HTML-CSS": {
        scale: 100,
        linebreaks: { automatic: true, width: "container" }
      },
      SVG: { linebreaks: { automatic: true } }
    });
    setTimeout(() => {
      MathJax.Hub.Queue([
        "Typeset",
        MathJax.Hub,
        document.getElementsByClassName("answers")
      ]);
    }, 1000);

    this.previousSelectedTabIndex.push(0);

    jQuery(document).ready(function($) {
      if (window.history && window.history.pushState) {
        $(window).on("popstate", function() {
          var hashLocation = location.hash;
          var hashSplit = hashLocation.split("#!/");
          var hashName = hashSplit[1];

          if (hashName !== "") {
            var hash = window.location.hash;
            if (hash === "") {
            }
          }
        });

        window.history.pushState("/", null, "./");
      }
    });

    $(window).unload(function() {
      Swal.fire({
        title: "Alert",
        text: "Unload ",
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "OK"
      }).then(result => {
        if (result.isConfirmed) {
        }
      });
    });

    // const modalRef = this.modal.open(this.modalContent)

    this.elem = document.documentElement;
    this.route.params.subscribe(params => {
      this.Section_Id = params["id"];
      this.set = localStorage.getItem("Set-id");
      this.paper = localStorage.getItem("Paper-id");
    });

    this.displayname = localStorage.getItem("display_name");
    this.categoryduration = localStorage.getItem("categoryduration");
    this.local.Id = this.Section_Id;
    this.local.set = sessionStorage.getItem("Set_Id");
    this.local.paper = sessionStorage.getItem("Paper_Id");
    this.local.schedule = sessionStorage.getItem("Schedule_Id");
    this.local.email = sessionStorage.getItem("email");
    this.local.schedule_master_Id = sessionStorage.getItem(
      "Schedule_Master_Id"
    );
    this.displayQuestions();

    this.timer = this.categoryduration;
    this.timer_alert = (this.timer - 2) * 60000;
    this.time = this.categoryduration * 60000;
    this.counter = this.categoryduration * 60;
    this.myTime = null;
    this.timings = null;
    this.timings = setTimeout(() => {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: "static",
        keyboard: false
      };
      //Open modal on pressing escape
      const modalRef = this.modal.open(this.modalTimerAlert, ngbModalOptions);
      setTimeout(() => {
        modalRef.close(this.modalTimerAlert);
      }, 5000);
    }, this.timer_alert);
    this.myTime = setTimeout(() => {
      clearTimeout(this.escapetime);
      this.escapetime = 0;

      // this.end_test();
      //this.audiourl = localStorage.getItem('videoblob');
      //this.essay_id = `q${this.questions[0].Id} `;
      //this.data_str[this.essay_id] = [this.audiourl, this.questions[0].Id];

      //this.save_data = this.data_str;
      if (this.isVideoRecording == true)
        this.stopVideoRecording(
          this.recordingQuestionRow,
          this.recordingQuestionIndex
        );

        if (this.isAudioRecording == true)
        this.stopAudioRecording(
          this.recordingQuestionRow,
          this.recordingQuestionIndex
        );

      this.submit_test();

      //this.modalRef.close(this.modalFinish);
      this.router.navigate(["section"]);
      this.modalCafe.close(this.modalContent);
    }, this.time);
    //},20000);
    this.countDown = Observable.timer(0, this.tick)
      .take(this.counter)
      .map(() => --this.counter);
  }

  displayQuestions() {
    this.quest.displayQuestion(this.local).subscribe(
      data => {
        this.questions = data.results;
        console.log("printing questions********", this.questions);
        this.selectedQuestionId = `q${this.questions[0].Id}`;
        console.log("this.selectedQuestionId", this.selectedQuestionId);
        

        for(let i =0;i<this.questions.length;i++){
          console.log("i********************",i)
          console.log("inside for",this.questions[i].type_name,this.questions[i].Id)
          if(this.questions[i].type_name == 'AudioAnswer'){
            this.audioOutputs.push(this.questions[i])
          }else  if(this.questions[i].type_name == 'VideoAnswer'){
            this.videoOutputs.push(this.questions[i])
          }
        }

        this.questions.map((question: any, index: any) => {
          if (
            question.q_url.indexOf(".mp3") > -1 ||
            question.q_url.indexOf(".wav") > -1 ||
            question.q_url.indexOf(".ogg") > -1 ||
            question.q_url.indexOf("www.youtube.com") > -1
          ) {
            var temp = `q${question.Id} `;
            this.setAudioVideoFlag[temp] = true;
            if (question.q_url.indexOf("www.youtube.com") > -1) {
              this.youtube_flag = true;
              this.setAudioVideoFlag[temp] = false;
              this.video_id =
                "https://www.youtube.com/embed/" +
                this.youtube_parser(this.q_url.q_url);
              this.safeSrc = this._sanitizer.bypassSecurityTrustResourceUrl(
                this.video_id
              );
            }
          } else {
            this.setAudioVideoFlag[temp] = false;
          }
        });

        this.first_question = this.questions[0];
        this.question_length = this.questions.length;
        for (var i = 0; i < data.results.length; i++) {
          this.fractionString1.push(data.results[i].Question_Text);
        }
        this.total_questions = this.questions.length;
        console.log("total_questions", this.total_questions);
        if (this.total_questions > 29) {
          this.questioncounter = true;
        }

        this.not_essay = true;
        this.userId = sessionStorage.getItem("id");
        this.email = sessionStorage.getItem("email");
        this.schedule_id = sessionStorage.getItem("Schedule_Id");
        this.questions.map(data => {
          console.log("data.type_name", data.type_name);
          // if(data.type_name == 'AudioAnswer'){
          //   this.isAudioRecordingArray[`q${data.Id}`] = false
          //   this.videoBlobUrlArray [`q${data.Id}`] = null
          // }
          // else
          // if (data.type_name == "VideoAnswer") {
            this.isVideoRecordingArray[`q${data.Id}`] = false;
            this.videoBlobUrlArray[`q${data.Id}`] = null;
          // }
          this.prevSelectedAnswerArray.set(`q${data.Id}`, [null]);
          this.blobArrays.set(`q${data.Id}`, [null, data.Id,this.userId,this.schedule_id,this.email,null]);
          this.fileSize[`q${data.Id}`] = null
        });
        console.log("this.fileSize",this.fileSize)
        console.log("this.blobArrays initial",this.blobArrays)

        console.log("videoBlobUrlArray*",this.videoBlobUrlArray)

        this.length1 = this.questions.length;
        for (var i = 0; i < this.length1; i++) {
          this.esarr[this.questions[i].Id] = null;
        }
        this.answer = data.resultanss;
        this.getCategory(this.questions[0].Question_Id);
        this.visited_count = this.length1 - 1;
        this.category = this.questions[0].Category_Name;
        this.total = this.questions.length;
        console.log(this.length1);
        for (var i = 0; i < this.length1; i++) {
          this.questionIdarray[i] = this.questions[i].Id;
        }
        console.log("questionIdarray", this.questionIdarray);
        this.book_mark[this.questionIdarray[0]] = false;

        for (var i = 0; i < this.length1; i++) {
          var temp = `q${this.questionIdarray[i]} `;

          this.save_answer[temp] = [
            null,
            null,
            this.questionIdarray[i],
            this.userId,
            this.schedule_id,
            this.email
          ];
        }
        for (var i = 0; i < this.length1; i++) {
          var temp = `q${this.questionIdarray[i]} `;
          this.essay_str[temp] = [null, this.questionIdarray[i]];
          this.data_str[temp] = [null, this.questionIdarray[i]];
          console.log(this.data_str);
        }
        for (var i = 0; i < this.length1; i++) {
          this.filter[this.questionIdarray[i]] = false;
        }
        this.unanswered = this.length1;
        this.answered = 0;

        return this.questions, this.questionIdarray;
      },
      err => {
        console.error(err);
      }
    );
  }

  getCategory(id) {
    console.log("inisde getcategory", id);
    this.answer_text = this.answer.filter(p => p.Question_Id == id);
    console.log("inisde answer_text", this.answer_text);

    return this.answer.filter(p => p.Question_Id == id);
  }

  @HostListener("window:blur", ["$event"])
  onBlur(event: any): void {
    this.popupcounter = this.popupcounter + 1;

    if (this.popupcounter <= 2) {
      this.modalRef = this.modal.open(this.modalStart);
      setTimeout(() => {
        this.modalRef.close(this.modalStart);
      }, 3000);
    }
  }

  update() {
    MathJax.Hub.Config({
      showMathMenu: false,
      // jax: ["input/TeX", "output/HTML-CSS"],
      tex2jax: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"]
        ]
        //processEscapes: true,
        // skipTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code']
      },
      menuSettings: { zoom: "Double-Click", zscale: "20%" },
      CommonHTML: { linebreaks: { automatic: true } },
      "HTML-CSS": {
        scale: 100,
        linebreaks: { automatic: true, width: "container" }
      },
      SVG: { linebreaks: { automatic: true } }
    });
    setTimeout(() => {
      MathJax.Hub.Queue([
        "Typeset",
        MathJax.Hub,
        document.getElementsByClassName("answers")
      ]);
    }, 1000);
  }

  // essayAreaEmpty(row, i) {

  //       // this.audiourl = localStorage.getItem('videoblob');
  //       // this.essay_id = `q${row.Id} `;

  //       // this.data_str[this.essay_id] = [this.audiourl, row.Id];
  //       //this.save_data = this.data_str;

  //       this.submit_test()
  // }

  //open roughwork space
  openroughspace() {
    if (this.myvar == true) {
      //this.myvar = false;
    } else {
      this.myvar = true;
    }
  }

  faFilter = faFilter;
  faPauseCircle = faPauseCircle;
  faHome = faHome;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faInfoCircle = faInfoCircle;
  faPencilAlt = faPencilAlt;

  //Filter color

  getcolor(row, i) {
    //
    //
    //
    let color = 'red';
    
    if (i == 0 && this.videoBlobUrlArray[`q${row.Id}`] == null) {
      color = '#F9C118'
      this.visited[0] = true
    }
    if (this.button_click == true && i != 0) {
      color = 'red'
      this.button_click = false;
    }
    if (this.visited[i] == true && this.videoBlobUrlArray[`q${row.Id}`] == null || this.roughspace_filter[row.Id] == false) {
      color = '#F9C118'
    }
    if (this.videoBlobUrlArray[`q${row.Id}`] != null && this.visited[i] == true || this.roughspace_filter[row.Id] == true) {
      color = 'green'
    }
    // if(this.book_mark[`q${row.Id}`] == true ){
      if(this.book_mark[row.Id] == true ){
      color = '#7000a0'
    }
    return color;
  }


  //visited function
  visit_func(i) {
    this.visitedArray = i;

    // this.save_essay=this.essay_str
    //
    // this.essayAreaEmpty(questionIdarray, i);
    let success = !this.visitedArrays.some(item => item == this.visitedArray);
    {
      this.visitedArrays.push(this.visitedArray);
      _.uniq(this.visitedArrays);
    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }
    return;
  }

  //get category end time

  end_time() {
    // this.todaysDataTime = formatDate(this.today, 'hh:mm', 'en-US', '+0530');
    var now = moment().format("hh:mm:ss");

    this.date = new Date();

    this.end_button = now;
  }

  //disable browser backbutton
  @HostListener("window:popstate", ["$event"])
  onBrowserBackBtnClose(event: Event) {
    event.preventDefault();
    //window.history.forward();
    this.router.navigate(["/"], { replaceUrl: true });
  }
  @HostListener("document:keyup", ["$event"])
  keyup(event: KeyboardEvent) {
    // const modalRef = this.modal.open(this.modalKeyboard)
    // setTimeout(() => {
    //   modalRef.close(this.modalContent)
    // }, 3000);
    if (event.keyCode === 44) {
      const modalRef = this.modal.open(this.modalKeyboard);
      setTimeout(() => {
        modalRef.close(this.modalKeyboard);
      }, 3000);

      setTimeout(() => {
        modalRef.close(this.modalKeyboard);
      }, 3000);
      //e.preventDefault();
      // alert('keyup')
      //this.copyToClipboard()
      this.focuscount += 1;
      if (this.focuscount >= 6) {
        //alert('f>2')
        this.submit_test();
        //this.exitFullScreen();
        this.final();
        modalRef.close(this.modalKeyboard);
        this.router.navigateByUrl("final");
      }
    }
  }

  onselect(row, i) {
    console.log("inisde onselectr", row, i);
    this.prevQuestionId = this.selectedQuestionId;
    this.selectedQuestionId = `q${row.Id}`;
    this.selectedIndex = i;
    console.log(
      "this.selectedQuestionId* inside onselect aftr",
      this.selectedQuestionId,
      this.prevQuestionId
    );

    this.previousSelectedTabIndex.push(i);
    this.visitedArray = i;
    console.log("tab_counter", this.tab_counter);
    this.tab_counter = this.tab_counter + 1;
    if (
      this.tab_counter == 1 &&
      this.videoBlobUrlArray[this.first_question.Id] != null
    ) {
      console.log("inisde if");
      this.visited[0] = true;
      this.visit_func(0);
      this.getcolor(this.first_question, 0);
    }
    this.visited[i] = true;
    let success = !this.visitedArrays.some(item => item == this.visitedArray);
    {
      this.visitedArrays.push(this.visitedArray);
      _.uniq(this.visitedArrays);
    }
    console.log("success", success);
    if (success == true && this.visited_count > 0) {
      console.log("inside if success true", this.visited_count, this.visit);
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }
    console.log("after success", `q${row.Id} `);

    this.essay_id = `q${row.Id} `;
    console.log("this.essay_id", this.essay_str[this.essay_id][0]);
    this.recordingflag = false;
    if (this.essay_str[this.essay_id][0] !== null) {
      this.recordingflag = true;
    } else {
      console.log("false");
    }
    this.currenturl = "";
    console.log("save_answer", this.save_answer);

    this.submit = this.save_answer;
    for (let i in this.submit) {
      console.log("inisde for loop", i);
      this.fill[this.submit[i][2]] = this.submit[i][3];
    }
    console.log("before category");
    console.log(
      "this.selectedQuestionId* inside onselect",
      this.selectedQuestionId,
      this.prevQuestionId
    );

    this.callIndividualSave();
    this.getCategory(row.Id);
    console.log("after categiry");
    this.router.navigate(["videorecord", row.Id]);
  }

  favoriteSeason: string;
  check;

  //next button
  maxNumberOfTabs: number;
  selectedIndex: number = 0;

  nextStep(questionIdarray, i) {
    console.log("inside next", questionIdarray[i + 1], i);
    var temp = `q${questionIdarray[i + 1]} `;
    console.log("this.essay_str[temp][0]", this.essay_str[temp][0]);
    if (this.essay_str[temp][0] === null) {
      this.recording = false;
      this.recordingflag = false;
    } else {
      this.recording = false;
      this.recordingflag = true;
    }
    this.currenturl = "";
    //  this.button_click=false;
    this.selectedIndex = i;
    console.log("selectedIndex", this.selectedIndex);

    this.audiourl = "";
    this.maxNumberOfTabs = this.length1;

    //this.submit = this.save_answer;

    this.visitedArray = i + 1;

    // this.save_essay=this.essay_str
    //
    // this.essayAreaEmpty(questionIdarray, i);
    let success = !this.visitedArrays.some(item => item == this.visitedArray);
    {
      this.visitedArrays.push(this.visitedArray);
      _.uniq(this.visitedArrays);
    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }

    this.visited[i + 1] = true;
    this.visited[i] = true;

    //   if(this.visited[i]==true && this.visited_count>0){
    //      this.visited_count=this.visited_count-1;
    //      this.visited_value[i]=false;
    //   }

    //
    //
    //

    for (let i in this.submit) {
      this.fill[this.submit[i][2]] = this.submit[i][3];
    }

    if (this.selectedIndex != this.length1) {
      this.selectedIndex = this.selectedIndex + 1;
      this.previousSelectedTabIndex.push(this.selectedIndex);
    }
    console.log(
      "q${questionIdarray[i]}",
      `q${questionIdarray[this.selectedIndex]}`
    );
    this.prevQuestionId = this.selectedQuestionId;
    this.selectedQuestionId = `q${questionIdarray[this.selectedIndex]}`;
    console.log(
      "this.selectedQuestionId* inside nextstep",
      this.selectedQuestionId,
      this.prevQuestionId
    );
    this.callIndividualSave();
    this.getCategory(questionIdarray[this.selectedIndex]);

    console.log("questionIdarray[i]", questionIdarray[this.selectedIndex]);

    this.router.navigate(["videorecord", questionIdarray[this.selectedIndex]]);
  }

  previousStep(questionIdarray, i) {
    // this.button_click=false;
    console.log(questionIdarray[i - 1]);
    var temp = `q${questionIdarray[i - 1]} `;
    if (this.essay_str[temp][0] === null) {
      this.recording = false;
      this.recordingflag = false;
    } else {
      this.recording = false;
      this.recordingflag = true;
    }

    this.currenturl = "";
    this.audiourl = "";
    this.selectedIndex = i;

    if (this.selectedIndex != 0) {
      this.selectedIndex = this.selectedIndex - 1;
      this.previousSelectedTabIndex.push(this.selectedIndex);
    }
    this.visited[i - 1] = true;
    this.visited[i] = true;
    this.visitedArray = i - 1;

    let success = !this.visitedArrays.some(item => item == this.visitedArray);
    {
      this.visitedArrays.push(this.visitedArray);
      _.uniq(this.visitedArrays);
    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }

    for (let i in this.submit) {
      this.fill[this.submit[i][2]] = this.submit[i][3];
    }
    console.log(
      "q${questionIdarray[i]}",
      `q${questionIdarray[i]}`,
      `q${questionIdarray[i + 1]}`,
      `q${questionIdarray[this.selectedIndex]}`
    );

    this.prevQuestionId = this.selectedQuestionId;
    this.selectedQuestionId = `q${questionIdarray[this.selectedIndex]}`;
    console.log(
      "this.selectedQuestionId* inside prevstep",
      this.selectedQuestionId,
      this.prevQuestionId
    );

    this.callIndividualSave();
    this.getCategory(questionIdarray[this.selectedIndex]);
    this.router.navigate(["videorecord", questionIdarray[this.selectedIndex]]);
  }

  // submit answers in user_answer table(all mcq's)
  submit_test() {
    console.log("inside submit test");
    console.log(this.questions[0].Id);
    this.end_time();
    // clearInterval(this.intervalId);
    if (this.sectioncount === null) {
      this.sectioncount = 0;
    }
    this.sectioncount++;
    localStorage.setItem("section_counter", JSON.stringify(this.sectioncount));
    // alert(this.sectioncount)
    this.category_start_time = sessionStorage.getItem("Start_Time");
    this.category_time.end_time = this.end_button;
    this.category_time.start_time = this.category_start_time;
    this.category_time.category_id = this.questions[0].Section_Id;
    this.category_time.user_id = sessionStorage.getItem("id");

    this.section_time.end_time = this.end_button;
    this.section_time.start_time = sessionStorage.getItem("Start_Time");
    this.section_time.section_name = localStorage.getItem("Section_Name");
    this.section_time.user_id = sessionStorage.getItem("id");
    this.section_time.email = sessionStorage.getItem("email");
    this.section_time.category_id = this.questions[0].Section_Id;
    clearTimeout(this.myTime);
    this.myTime = 0;
    clearTimeout(this.timings);
    this.timings = 0;
    localStorage.setItem(
      `${this.category_time.user_id}[${this.questions[0].Section_Id}]`,
      "completed"
    );
    localStorage["targetSection" + this.questions[0].Section_Id] = 0;
    var tempp = localStorage.getItem(
      "targetSection" + this.questions[0].Section_Id
    );
    localStorage["section_button" + this.questions[0].Section_Id] = 0;
    var arr = localStorage.getItem(
      "section_button" + this.questions[0].Section_Id
    );
    console.log(
      "this.blobArrays.get(this.prevQuestionId)",
      this.blobArrays.get(this.prevQuestionId)
    );
    this.blobArrays.forEach((array, key) => {
      array.splice(-1, 1);
    });
    console.log("this.blobArrays before final save",this.blobArrays)
    this.quest.submit_data(this.blobArrays).subscribe(
      async data => {
        console.log("data.code inside video", data.code);
        if (data.code === 200) {
          Swal.fire({
            title: "Success",
            text: "Answers Saved Successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "OK"
          }).then(result => {
            if (result.isConfirmed) {
            }
          });
        } else if (data.code === 400) {
          Swal.fire({
            title: "Alert",
            text: data.failed,
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "OK"
          }).then(result => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          });
        }
      },
      err => {
        //console.error(err);
      }
    );
    this.exitFullScreen();
    this.send_time();
    this.sectiontime();
    this.router.navigateByUrl("section");
  }

  async callIndividualSave() {
    console.log(
      "inside this.callIndividualSave()",
      this.prevQuestionId,
      this.selectedQuestionId,
      this.prevSelectedAnswerArray
    );

    console.log("this.blobArrays inside callIndividualSave",this.blobArrays)

    this.prevSelectedAnswer = this.prevSelectedAnswerArray.get(
      this.prevQuestionId
    );
    this.dataURLToSave = this.blobArrays.get(this.prevQuestionId);
    console.log("dataURLToSave[0] != null", this.dataURLToSave[0] != null);
    // console.log(" this.prevSelectedAnswer[0] != ", this.prevSelectedAnswer[0] != this.dataURLToSave[0].toString())
    
    if (
      this.dataURLToSave && this.dataURLToSave[0] != null &&
      this.prevSelectedAnswer && this.prevSelectedAnswer[0] != this.dataURLToSave[0].toString()
    ) {
      console.log("condition passed")
          await this.checkFalseResponses();
          await this.prepareCombinedIndividualAnsArray();
          await this.saveBlob();
    }
  }

  async checkFalseResponses() {
    console.log("inside checkFalseResponses")
    this.falseResponseIds = [];
    this.blobArrays.forEach((array, key) => {
      console.log("array[5 inside checkFalseResponses",array[5])
      if (array[5] == false) {
        this.falseResponseIds.push(key);
      }
    });
  }

  async prepareCombinedIndividualAnsArray(){
    console.log("inside prepareCombinedIndividualAnsArray")
    this.combinedIndividualAnsArray = [];
    this.dataURLToSave = this.blobArrays.get(this.prevQuestionId);
    this.dataURLToSave.splice(-1, 1);

    if (this.falseResponseIds.length > 0) {
      console.log("this.falseResponseIds length > 0",this.falseResponseIds)
      for (let i = 0; i < this.falseResponseIds.length; i++) {
        console.log("inside for")
          this.array = this.blobArrays.get(this.falseResponseIds[i]);
          this.combinedIndividualAnsArray.push([
            this.array[0],
            this.array[1],
            this.array[2],
            this.array[3],
            this.array[4],
          ]);
      }
      this.combinedIndividualAnsArray.push(this.dataURLToSave);
    } else {
      this.combinedIndividualAnsArray = this.dataURLToSave;
    }
    console.log('combinedIndividualAnsArray',this.combinedIndividualAnsArray)
  }

  async saveBlob(){
    this.quest
    .submit_individual_audio(this.combinedIndividualAnsArray, this.falseResponseIds.length)
    .subscribe(
      async data => {
        console.log("data.code inside video", data.code);
        if (data.code === 200) {
          console.log("inside data 200", this.prevQuestionId, [
            this.dataURLToSave[0]
          ]);
          this.updateFlag(this.prevQuestionId,true)
          this.prevSelectedAnswerArray.set(this.prevQuestionId, [
            this.dataURLToSave[0].toString()
          ]);
          console.log(
            "this.prevSelectedAnswerArray inside save",
            this.prevSelectedAnswerArray
          );
        } else if (data.code === 400) {
          console.log("400 response");
          this.updateFlag(this.prevQuestionId,false)
        } else {
          console.log("submit_indi_audio else");
          this.updateFlag(this.prevQuestionId,false)
        }
      },
      err => {
        //console.error(err);
        console.log("data.code is 504");
          this.updateFlag(this.prevQuestionId,false)
      }
    );
  }

  async updateFlag(questionId,flag:boolean){
    console.log("flag inside updateFlagForFreeText",flag)
    this.blobArrays.get(questionId)[5] = flag;
    for (let i = 0; i < this.falseResponseIds.length; i++) {
      if(flag == true){
        this.prevSelectedAnswerArray.set(this.falseResponseIds[i], [
          this.blobArrays.get(this.falseResponseIds[i])[0]
        ]);
      }
      this.blobArrays.get(this.falseResponseIds[i])[5] = flag;
    }
    this.dataURLToSave = [];
  }

  async sectiontime() {
    // alert("sendtime")
    this.quest.section_time(this.section_time).subscribe(
      async data => {},

      err => {
        //console.error(err);
      }
    );
  }

  //Save section time
  async send_time() {
    // alert("sendtime")
    this.quest.cate_time(this.category_time,this.userId,this.schedule_id,this.email).subscribe(
      async data => {},

      err => {
        //console.error(err);
      }
    );
  }

  //submit answers
  // async end_test() {
  //   this.end_time();
  //   // clearInterval(this.intervalId);
  //   if (this.sectioncount === null) {
  //     this.sectioncount = 0;
  //   }
  //   this.sectioncount++;

  //   localStorage.setItem("section_counter", JSON.stringify(this.sectioncount));
  //   this.category_start_time = sessionStorage.getItem('Start_Time')
  //   this.category_time.end_time = this.end_button
  //   this.category_time.start_time = this.category_start_time;
  //   this.category_time.category_id = this.questions[0].Section_Id;
  //   this.category_time.user_id = sessionStorage.getItem('id')

  //   // this.section_time.start_time = sessionStorage.getItem('Start_Time')
  //   // this.section_time.section_name = localStorage.getItem('Section_Name');
  //   // this.section_time.user_id = sessionStorage.getItem('Id')

  //   this.section_time.end_time = this.end_button
  //   this.section_time.start_time = sessionStorage.getItem('Start_Time')
  //   this.section_time.section_name = localStorage.getItem('Section_Name');
  //   this.section_time.user_id = sessionStorage.getItem('id')
  //   this.section_time.email = sessionStorage.getItem('email')

  //   localStorage['targetSection' + this.questions[0].Section_Id] = 0;
  //   var tempp = localStorage.getItem(
  //     'targetSection' + this.questions[0].Section_Id
  //   );
  //   localStorage['section_button' + this.questions[0].Section_Id] = 0;
  //   var arr = localStorage.getItem('section_button' + this.questions[0].Section_Id);

  //   // this.submit = this.save_answer;
  //   // this.save_data = this.blobArrays
  //   console.log("this.blobArrays.get(this.prevQuestionId)",this.blobArrays.get(this.prevQuestionId))
  //   const data = await this.quest.submit_data(this.blobArrays.get(this.prevQuestionId)).toPromise();

  //   this.send_time();
  //   this.exitFullScreen();
  //   this.sectiontime();
  //   this.router.navigateByUrl('section');

  //   //this.modalService.dismissAll();

  // }

  youtube_parser(url) {
    var regExp = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
    var match = url.match(regExp);
    return match && match[1].length == 11 ? match[1] : false;
  }

  //capture right click event and display warning msg
  @HostListener("contextmenu", ["$event"])
  onRightClick(event) {
    event.preventDefault();
    const modalRef = this.modal.open(this.modalRightClick);
    setTimeout(() => {
      modalRef.close(this.modalContent);
    }, 3000);
    setTimeout(() => {
      modalRef.close(this.modalRightClick);
    }, 3000);
  }

  @HostListener("document:keydown", ["$event"])
  keydown(event: KeyboardEvent) {
    this.keypress = true;
    if (event.key === "Alt" || event.key === "Tab" || event.key === "Meta") {
      this.focuscount += 1;
      const modalRef = this.modal.open(this.modalKeyboard);
      setTimeout(() => {
        modalRef.close(this.modalKeyboard);
      }, 3000);
      event.preventDefault();
      event.stopPropagation();
      if (this.focuscount >= 6) {
        //alert('f>2')
        this.submit_test();
        this.final();
        //this.exitFullScreen();

        this.router.navigateByUrl("final");
      }
    }
    if (
      event.key === "F5" ||
      event.key === "F1" ||
      event.key === "F12" ||
      event.key === "Escape" ||
      event.key === "Control"
    ) {
      event.preventDefault();
      const modalRef = this.modal.open(this.modalKeyboard);
      setTimeout(() => {
        modalRef.close(this.modalKeyboard);
      }, 3000);
    }
  }

  //Disable keyboard combinations
  @HostListener("document:keydown.Control.Shift.j", ["$event"])
  @HostListener("document:keydown.Control.Shift.i", ["$event"])
  @HostListener("document:keydown.Control.Shift.p", ["$event"])
  @HostListener("document:keydown.Control.Shift.c", ["$event"])
  @HostListener("document:keydown.Control.Shift.m", ["$event"])
  @HostListener("document:keydown.Control.Shift.d", ["$event"])
  @HostListener("document:keydown.Control.o", ["$event"])
  @HostListener("document:keydown.Control.p", ["$event"])
  @HostListener("document:keydown.Control.Tab", ["$event"])
  @HostListener("document:keydown.Shift.Tab", ["$event"])
  @HostListener("document:keydown.Alt.Tab", ["$event"])
  @HostListener("document:keydown.Control.c", ["$event"])
  Keydown(e: KeyboardEvent) {
    this.keypress = true;
    //  const modalRef = this.modal.open(this.modalKeyboard)
    // setTimeout(() => {
    //   modalRef.close(this.modalContent)
    // }, 3000);

    this.focuscount += 1;
    e.preventDefault();
    e.stopPropagation();

    if (this.focuscount >= 6) {
      //alert('f>2')
      this.submit_test();
      this.final();
      //this.exitFullScreen();

      //  modalRef.close(this.modalKeyboard)

      this.router.navigateByUrl("final");
    }
  }

  //Track fullscreen change
  @HostListener("document:fullscreenchange", ["$event"])
  @HostListener("document:webkitfullscreenchange", ["$event"])
  @HostListener("document:mozfullscreenchange", ["$event"])
  @HostListener("document:MSFullscreenChange", ["$event"])
  fullscreenmode(event) {
    event.preventDefault();
    if (window.innerHeight == screen.height) {
    }
    console.log("toggleClass before if", this.toggleClass);

    if (this.toggleClass == "ft-minimize") {
      console.log("toggleClass inside if", this.toggleClass);
      this.toggleClass = "ft-maximize";

      let ngbModalOptions: NgbModalOptions = {
        backdrop: "static",
        keyboard: false
      };

      //Open modal on pressing escape

      this.modalCafe = this.modal.open(this.modalContent, ngbModalOptions);
      this.escape_count = this.escape_count + 1;
      if (this.escape_count > 6 || this.popupcounter > 6) {
        this.modalCafe.close(this.modalContent);
        clearTimeout(this.escapetime);
        this.escapetime = 0;
        this.n = JSON.parse(localStorage.getItem("on_load_counter"));
        localStorage.setItem("on_load_counter", JSON.stringify(this.zero));
        this.audiourl = localStorage.getItem("videoblob");
        this.essay_id = `q${this.questions[0].Id} `;
        this.data_str[this.essay_id] = [this.audiourl, this.questions[0].Id];
        // this.blobArrays = JSON.parse(blobArrayString)
        // this.save_data = this.blobArrays
        this.submit_test();
        this.final();
        this.modalCafe.close(this.modalContent);
        this.router.navigateByUrl("final");
      }
      setTimeout(() => {
        clearTimeout(this.escapetime);
        this.escapetime = 0;

        if (this.buttonclick == false) {
          this.modalCafe.close(this.modalContent);

          this.n = JSON.parse(localStorage.getItem("on_load_counter"));
          localStorage.setItem("on_load_counter", JSON.stringify(this.zero));
          this.audiourl = localStorage.getItem("videoblob");
          this.essay_id = `q${this.questions[0].Id} `;
          this.data_str[this.essay_id] = [this.audiourl, this.questions[0].Id];
          // this.blobArrays = JSON.parse(blobArrayString)
          // this.save_data = this.blobArrays;
          this.submit_test();
          this.modalCafe.close(this.modalContent);
          this.final();
          this.router.navigateByUrl("final");
        }
      }, this.escapetime);
    } else {
      console.log("toggleClass inside else", this.toggleClass);

      this.toggleClass = "ft-minimize";
    }
  }

  //endtest for malpracticed users
  final() {
    localStorage.setItem("on_load_counter", JSON.stringify(this.zero));
    this.n = 0;
    localStorage.setItem("section_counter", JSON.stringify(this.zero));

    this.user_logon_time = localStorage.getItem("Logon time");
    this.todaysDataTime = formatDate(this.today, "hh:mm:ss", "en-US", "+0530");

    this.user_loggoff_time = this.todaysDataTime;

    this.islogged.login_time = this.user_logon_time;
    this.islogged.logoff_time = this.user_loggoff_time;
    var schedule_master = sessionStorage.getItem('Schedule_Master_Id')

    this.Endtest.endtest(this.islogged,this.userId,schedule_master).subscribe(
      data1 => {
        this.logged = true;
        this.evaluate();
        //       localStorage.clear();
        // sessionStorage.clear();
      },
      err => {
        //console.error(err);
      }
    );
  }

  //evaluate malpracticed users
  evaluate() {
    console.log("inside evaluate**",this.userId,this.schedule_id)

    this.evaluate_user.evaluate(this.userId,this.schedule_id).subscribe(
      data => {
        //this.end_time();
      },
      err => {
        //console.error(err);
      }
    );
  }

  //Open fullscreen
  openFullscreen() {
    this.buttonclick = true;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  //exitfullscreen
  exitFullScreen() {
    const document: any = window.document;
    if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }

  // Observable to collect information from an api
  fetchData() {
    this.check_loggedin.Test_Taker_User_Id = sessionStorage.getItem("id");
    this.check_loggedin.schedule_id = sessionStorage.getItem("Schedule_Id");
    this.Endtest.checkisLogged(this.check_loggedin).subscribe(
      data => {
        if (data.results[0].Is_terminated == "YES") {
          // clearInterval(this.intervalId);
          // clearImmediate(this.intervalId);
          clearTimeout(this.intervalId);
          this.n = JSON.parse(localStorage.getItem("on_load_counter"));
          localStorage.setItem("on_load_counter", JSON.stringify(this.zero));
          this.essay_id = `q${this.questions[0].Id} `;
          this.data_str[this.essay_id] = [
            this.audiodataurl,
            this.questions[0].Id
          ];
          // this.save_data = this.blobArrays;
          this.submit_test();
          this.final();
          this.modalCafe.close(this.modalContent);
          this.router.navigateByUrl("final");
        }
      },
      err => {
        //console.error(err);
      }
    );
  }

  intervalId = setTimeout(() => {
    this.fetchData();
  }, 30000);

  bookmark(questionIdarray, i) {
    this.bookmark_counter = this.bookmark_counter + 1;
    this.book_mark[questionIdarray[i]] = true;
  }

  remove_bookmark(questionIdarray, i) {
    this.bookmark_counter = this.bookmark_counter - 1;
    this.book_mark[questionIdarray[i]] = false;
  }

  showImagePreview(questionImage) {
    let ngbModalOptions: NgbModalOptions = {
      size: "lg"
    };

    this.modal.open(this.modalImagePreview, ngbModalOptions);
    this.currentThumbnail = questionImage;
  }

  startVideoRecording(row, i) {
    console.log("inside startVideoRecording",row,i)
    console.log("inisde startVideoRecording 2", this.isVideoRecording);
    this.recordingQuestionRow = row;
    this.recordingQuestionIndex = i;

    this.isVideoRecording = true;
    this.videoElement.forEach((childComponent, index) => {
      console.log("videoElement inside startvideo",childComponent,index)
    })

    if (this.isVideoElementReady) {
      console.log("inisde true*******");
      this.videoElement.forEach((childComponent, index) => {
        console.log("inside for loop", index, i, childComponent);
        if (i == index) {
          console.log("inside sekected index start", i, index);

          this.video = childComponent.nativeElement;
          this.video.controls = false;
          console.log("inside start", this.isVideoRecordingArray[`q${row.Id}`]);
          var temp = `q${row.Id} `;
          this.isVideoRecordingArray[temp] = true;
          this.videoRecordingService
            .startRecording(this.videoConf)
            .then(stream => {
              console.log("inside start recording stream", stream, this.video);
              this.video.srcObject = stream;
              this.video.play();
              this.video.volume = 0;
              this.video.muted = 0;
            })
            .catch(function(err) {
              console.log(err.name + ": " + err.message);
            });
        }
      });
    }

    // }
  }

  stopVideoRecording(row, i) {
    console.log("inside stopVideoRecording",row,i)
    console.log("this.video***",this.video)
    console.log("videoBlobUrlArray", this.videoBlobUrlArray);
    this.videoElement.forEach((childComponent, index) => {
      console.log("videoElement inside stopvideo",childComponent,index)
    })
    this.videoRecordingService.stopRecording(row.Id);
    this.videoElement.forEach((childComponent, index) => {
      console.log("inside for loop", index, i, childComponent);
      if (i == index) {
        console.log("inside sekected index stoprec", i, index);
        this.video = childComponent.nativeElement;
        this.video.volume = 1;
        this.video.muted = 1;
        this.video.srcObject = this.videoBlobUrlArray["q" + row.Id];
        this.isVideoRecording = false;
        this.video.controls = true;
      }
    });
    var temp = `q${row.Id} `;
    this.isVideoRecordingArray[temp] = true;
    // if(this.reachedMaxTime == false){
    this.unanswered = this.unanswered - 1;
    this.answered = this.answered + 1;
    // }

    // }
  }

  clearVideoRecordedData(row, i) {
    console.log(
      "videoBlobUrlArray inside clear*****",
      this.videoBlobUrlArray,
      row.Id
    );

    // this.videoBlobUrl = null;
    this.videoBlobUrlArray[`q${row.Id}`] = null;
    // this.blobArrays.map((data) => {
    //   if(data.questionId == row.Id){
    //     data.imageURL = null
    //   }
    // })
    this.blobArrays.set(`q${row.Id}`, [null, row.Id,,this.userId,this.schedule_id,this.email,null]);
    this.videoElement.forEach((childComponent, index) => {
      console.log("inside for loop", index, i, childComponent);
      if (i == index) {
        console.log("inside sekected index clear", i, index);
        this.video = childComponent.nativeElement;
        this.video.srcObject = null;
        this.video.controls = false;
      }
      // Access individual child components and perform actions
    });
    // this.video.srcObject = null;
    // this.video.controls = false;
    console.log("this.videoBlobUrlArray after clear", this.videoBlobUrlArray);
    this.unanswered = this.unanswered + 1;
    this.answered = this.answered - 1;
    this.ref.detectChanges();
  }

  startAudioRecording(row, i) {
    console.log("inside startAudioRecording****", row);
    this.recordingQuestionRow = row;
    this.recordingQuestionIndex = i;
    if (this.isAudioElementReady) {
      console.log("inisde true*******");
      this.videoElement.forEach((childComponent, index) => {
        console.log("videoElement inside start",childComponent,index)
      })
console.log("this.audioOutputs",this.audioOutputs)
this.audioOutputs.map((data,index) =>{
  console.log("id",data.Id,row.Id)
  // if(data.Id == row.Id){
  //      i = index
  // }
})
console.log("i",i)
      this.videoElement.forEach((childComponent, index) => {
        console.log("inside for loop", index, i, childComponent);
        if (i == index) {
          console.log("inside sekected index start", i, index);

          this.audio = childComponent.nativeElement;
          this.audio.controls = false;
          console.log("inside start", this.isAudioRecordingArray[`q${row.Id}`]);
          var temp = `q${row.Id} `;
          this.isAudioRecordingArray[temp] = true;
        }
      });
    }
    this.isAudioRecording = true;
    this.audioRecordingService.startRecording();
  }

  stopAudioRecording(row, i) {
    console.log("row inside stop", row.Id);

    this.audioRecordingService.stopRecording(row.Id);
    this.videoElement.forEach((childComponent, index) => {
      console.log("videoElement inside stop",childComponent,index)
    })
    this.videoElement.forEach((childComponent, index) => {
      console.log("inside for loop", index, i, childComponent);
      if (i == index) {
        console.log("inside sekected index stoprec**", i, index);
        this.isAudioRecording = false;
        var temp = `q${row.Id} `;
        this.isAudioRecordingArray[temp] = true;
        this.audio = childComponent.nativeElement;
        this.audio.volume = 1;
        // this.audio.muted = 1;
        this.audio.srcObject = this.videoBlobUrlArray["q" + row.Id];
        this.audio.controls = true;
      }
    });
    this.isAudioRecording = false;
    // var temp =  `q${row.Id} `;
    // this.isAudioRecordingArray[temp] = true
    console.log("audio", this.audio);
    // if(this.reachedMaxTime == false){
    this.unanswered = this.unanswered - 1;
    this.answered = this.answered + 1;
    // }
  }

  clearAudioRecordedData(row, i) {
    console.log("row inisde ckea", row.Id);
    // this.audioBlobUrl = null;
    this.videoBlobUrlArray[`q${row.Id}`] = null;
    this.videoElement.forEach((childComponent, index) => {
      console.log("inside for loop", index, i, childComponent);
      if (i == index) {
        console.log("inside sekected index clear", i, index);
        this.audio = childComponent.nativeElement;
        this.audio.srcObject = null;
        this.audio.controls = false;
      }
    });
    this.unanswered = this.unanswered + 1;
    this.answered = this.answered - 1;
    this.blobArrays.set(`q${row.Id}`, [null, row.Id,,this.userId,this.schedule_id,this.email,null]);
  }
}




//Time Countdown
@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);


    return ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);
  }

}

const blobToBase64 = blob => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

